import React, { useMemo } from 'react';
import { Table, Card, Icon, Badge } from 'antd';

const pulseStyles = `
@keyframes icon-beat {
  0%, 100% { transform: scale(1); }
  50%       { transform: scale(1.22); }
}
.mat-beat { animation: icon-beat 1.8s ease-in-out infinite; }
.mat-row-stripe td { background: #f7f9ff !important; }
`;

const MaterialPublicTable = (props) => {
	const { itemList } = props;

	const stats = useMemo(() => {
		if (!itemList || itemList.length === 0) return { total: 0, customers: 0 };
		const customers = new Set(itemList.map(i => i.customer_label)).size;
		return { total: itemList.length, customers };
	}, [itemList]);

	const columns = [
		{
			key: 'epcode',
			title: 'CODE',
			dataIndex: 'code',
			width: 130,
			sorter: (a, b) => a.code.localeCompare(b.code),
			sortDirections: ['ascend', 'descend'],
			render: (data) => data.toString().toUpperCase(),
		},
		{
			key: 'mspecs',
			title: 'MATERIAL SPECIFICATION',
			dataIndex: 'mspecs',
			width: 220,
			sorter: (a, b) => a.mspecs.localeCompare(b.mspecs),
			sortDirections: ['ascend', 'descend'],
			render: (data) => data.toString().toUpperCase(),
		},
		{
			key: 'itemdesc',
			title: 'ITEM DESCRIPTION',
			dataIndex: 'itemdesc',
			width: 220,
			sorter: (a, b) => a.itemdesc.localeCompare(b.itemdesc),
			sortDirections: ['ascend', 'descend'],
			render: (data) => data.toString().toUpperCase(),
		},
		{
			key: 'partnum',
			title: 'PART NO.',
			dataIndex: 'partnum',
			width: 120,
			sorter: (a, b) => a.partnum.localeCompare(b.partnum),
			sortDirections: ['ascend', 'descend'],
			render: (data) => data.toString().toUpperCase(),
		},
		{
			key: 'requiredqty',
			title: 'REQUIRED QTY',
			dataIndex: 'requiredqty',
			width: 110,
		},
		{
			key: 'outs',
			title: 'OUTS',
			dataIndex: 'outs',
			width: 70,
		},
		{
			key: 'customer_label',
			title: 'CUSTOMER',
			dataIndex: 'customer_label',
			width: 200,
			sorter: (a, b) => a.customer_label.localeCompare(b.customer_label),
			sortDirections: ['ascend', 'descend'],
			render: (data) => data.toString().toUpperCase(),
		},
		{
			key: 'remarks',
			title: 'REMARKS',
			dataIndex: 'remarks',
			width: 160,
		},
	];

	return (
		<div style={{ padding: '8px 0' }}>
			<style>{pulseStyles}</style>
			
			<Card
				bordered={false}
				style={{
					borderRadius: 10,
					boxShadow: '0 2px 12px rgba(24,144,255,0.07)',
					border: '1px solid #e6f0ff',
				}}
				bodyStyle={{ padding: '0 0 8px 0' }}
			>
				<div style={{
					padding: '14px 20px 12px',
					borderBottom: '1px solid #f0f5ff',
					display: 'flex',
					alignItems: 'center',
					gap: 8,
				}}>
					<Icon type="database" className="mat-beat" style={{ color: '#1890ff', fontSize: 16 }} />
					<span style={{
						fontWeight: 700,
						fontSize: 13,
						color: '#262626',
						letterSpacing: '0.5px',
					}}>
						MATERIAL RECORDS
					</span>
					<Badge
						count={stats.total}
						style={{
							backgroundColor: '#1890ff',
							fontSize: 11,
							fontWeight: 600,
						}}
						overflowCount={9999}
					/>
					<span style={{ marginLeft: 'auto', fontSize: 12, color: '#8c8c8c' }}>
						<Icon type="team" style={{ marginRight: 4 }} />
						{stats.customers} Customers
					</span>
				</div>

				<Table
					columns={columns}
					dataSource={itemList}
					bordered={true}
					size="middle"
					scroll={{ x: 'max-content' }}
					style={{ margin: '0' }}
					rowClassName={(_, idx) => idx % 2 === 0 ? '' : 'mat-row-stripe'}
					pagination={{
						pageSizeOptions: ['10', '25', '50', '100', '500'],
						showSizeChanger: true,
						showTotal: (total, range) =>
							`Showing ${range[0]}-${range[1]} of ${total} items`,
						style: { padding: '8px 16px 0', marginBottom: 0 }
					}}
					rowKey="id"
				/>
			</Card>
		</div>
	);
};

export default MaterialPublicTable;